import { CmmResponseStatus } from "../../../../enums/cmmResponseStatus";

export const allResponseStatusOptions = [
  { label: "Approved", value: CmmResponseStatus.APPROVED },
  { label: "Auth Not Required", value: CmmResponseStatus.AUTH_NOT_REQUIRED },
  { label: "Denied", value: CmmResponseStatus.DENIED },
  { label: "Pending", value: CmmResponseStatus.PENDING },
  { label: "Onshore Assistance", value: CmmResponseStatus.ONSHORE_ASSISTANCE },
  {
    label: "Not Correct Processor",
    value: CmmResponseStatus.NOT_CORRECT_PROCESSOR,
  },
  { label: "Drug Not Covered", value: CmmResponseStatus.DRUG_NOT_COVERED },
  { label: "NA Outcome", value: CmmResponseStatus.NA_OUTCOME },
  { label: "Approval on file", value: CmmResponseStatus.APPROVAL_ON_FILE },
  { label: "Denial on file", value: CmmResponseStatus.DENIAL_ON_FILE },
  { label: "Case on file", value: "Case on file" },
  { label: "Send To Client", value: CmmResponseStatus.SEND_TO_CLIENT },
];
